import React from 'react';
import {
  ACCESS_TABS, INFO_SECTIONS, FILES_CAPABILITIES,
  ACCESS_FILE_CATEGORIES, FILE_CATEGORY_CAPABILITIES,
  ACCESS_SHEETS, EDITOR_ACCESS_LEVELS,
  normalizeAccessConfig,
} from '../../utils/stakeholderAccess';
import './AccessConfigEditor.css';

// Paydaş erişim yapılandırma editörü.
// value: AccessConfig | null  →  null verilirse default ile başlar.
// onChange: (newConfig) => void
// dense: true → kompakt mod (paydaş popover'ı için)
const AccessConfigEditor = ({ value, onChange, dense = false }) => {
  const cfg = normalizeAccessConfig(value);

  const setTabEnabled = (key, val) => {
    onChange({ ...cfg, tabs: { ...cfg.tabs, [key]: { ...cfg.tabs[key], enabled: val } } });
  };
  const setInfoSection = (key, val) => {
    onChange({
      ...cfg,
      tabs: {
        ...cfg.tabs,
        info: { ...cfg.tabs.info, sections: { ...cfg.tabs.info.sections, [key]: val } },
      },
    });
  };
  const setFilesCap = (key, val) => {
    onChange({ ...cfg, tabs: { ...cfg.tabs, files: { ...cfg.tabs.files, [key]: val } } });
  };
  const setCatField = (catKey, field, val) => {
    onChange({
      ...cfg,
      fileCategories: {
        ...cfg.fileCategories,
        [catKey]: { ...cfg.fileCategories[catKey], [field]: val },
      },
    });
  };
  const setSheet = (key, val) => {
    onChange({ ...cfg, sheets: { ...cfg.sheets, [key]: val } });
  };
  const setEditorAccess = (lvl) => {
    onChange({ ...cfg, editorAccess: lvl });
  };

  return (
    <div className={`acfg ${dense ? 'acfg-dense' : ''}`}>
      <div className="acfg-section">
        <div className="acfg-section-title">Sekmeler</div>
        <div className="acfg-tab-list">
          {ACCESS_TABS.map(t => {
            const enabled = !!cfg.tabs[t.key]?.enabled;
            return (
              <div key={t.key} className="acfg-tab-row">
                <label className="acfg-check acfg-tab-main">
                  <input
                    type="checkbox"
                    checked={enabled}
                    onChange={e => setTabEnabled(t.key, e.target.checked)}
                  />
                  <span>{t.label}</span>
                </label>
                {t.key === 'info' && enabled && (
                  <div className="acfg-tab-sub">
                    {INFO_SECTIONS.map(s => (
                      <label key={s.key} className="acfg-check acfg-sub">
                        <input
                          type="checkbox"
                          checked={!!cfg.tabs.info.sections[s.key]}
                          onChange={e => setInfoSection(s.key, e.target.checked)}
                        />
                        <span>{s.label}</span>
                      </label>
                    ))}
                  </div>
                )}
                {t.key === 'files' && enabled && (
                  <div className="acfg-tab-sub">
                    {FILES_CAPABILITIES.map(c => (
                      <label key={c.key} className="acfg-check acfg-sub">
                        <input
                          type="checkbox"
                          checked={!!cfg.tabs.files[c.key]}
                          onChange={e => setFilesCap(c.key, e.target.checked)}
                        />
                        <span>{c.label}</span>
                      </label>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="acfg-section">
        <div className="acfg-section-title">Dosya Kategorileri</div>
        <table className="acfg-cat-table">
          <thead>
            <tr>
              <th></th>
              <th title="Bu kategoriye erişim">Erişim</th>
              {FILE_CATEGORY_CAPABILITIES.map(c => (
                <th key={c.key} title={c.label}>{c.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ACCESS_FILE_CATEGORIES.map(cat => {
              const cur = cfg.fileCategories[cat.key] || {};
              const enabled = !!cur.enabled;
              return (
                <tr key={cat.key} className={enabled ? '' : 'acfg-cat-disabled'}>
                  <td className="acfg-cat-label">{cat.label}</td>
                  <td className="acfg-cat-cell">
                    <input
                      type="checkbox"
                      checked={enabled}
                      onChange={e => setCatField(cat.key, 'enabled', e.target.checked)}
                    />
                  </td>
                  {FILE_CATEGORY_CAPABILITIES.map(c => (
                    <td key={c.key} className="acfg-cat-cell">
                      <input
                        type="checkbox"
                        disabled={!enabled}
                        checked={enabled && !!cur[c.key]}
                        onChange={e => setCatField(cat.key, c.key, e.target.checked)}
                      />
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="acfg-section">
        <div className="acfg-section-title">Editör Paftalari</div>
        <div className="acfg-checks">
          {ACCESS_SHEETS.map(s => (
            <label key={s.key} className="acfg-check">
              <input
                type="checkbox"
                checked={!!cfg.sheets[s.key]}
                onChange={e => setSheet(s.key, e.target.checked)}
              />
              <span>{s.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="acfg-section">
        <div className="acfg-section-title">Editör Yetki Seviyesi</div>
        <div className="acfg-radios">
          {EDITOR_ACCESS_LEVELS.map(l => (
            <label key={l.key} className="acfg-radio">
              <input
                type="radio"
                name="acfg-editor-access"
                checked={cfg.editorAccess === l.key}
                onChange={() => setEditorAccess(l.key)}
              />
              <span>{l.label}</span>
            </label>
          ))}
        </div>
        <div className="acfg-hint">
          Düzenle / Tam yetki yalnız proje sahibinde tutulur — paydaşlara verilmez.
        </div>
      </div>
    </div>
  );
};

export default AccessConfigEditor;
